/* eslint-disable react/jsx-no-comment-textnodes */
import React from 'react';
import styled from 'styled-components';
import Button from '../v5_buttons/Button';
import updateDisplay from '../../../utils/suppress';

/* eslint-disable import/no-extraneous-dependencies */
const pmUuid = require('@postman/uuid');
/* eslint-enable */

/* eslint-disable no-useless-escape, react/prop-types,jsx-a11y/mouse-events-have-key-events  */
const triggerGA = (category, label) => {
  return (
    category &&
    label &&
    window.pmt &&
    window.pmt('ga', ['send', 'event', category, 'Click', label])
  );
};

const PricingButton = styled(Button)`
  font-size: 14px;
  padding: 9px 20px;
  width: 100%;
  height: 38px;
`;

const TableHeaderColumn = styled.th`
  vertical-align: top !important;
  padding: 24px 10px !important;
  font-family: ${(props) => props.theme.fonts.Inter};

  p {
    color: ${(props) => props.theme.colors.grey_90};
    font-family: ${(props) => props.theme.fonts.Inter};
    margin-bottom: 0;
    &.plan-price {
      font-family: ${(props) => props.theme.fonts.Inter};
      display: inline;
      font-size: 24px !important;

      @media screen and (max-width: 992px) {
        margin-top: 2rem;
      }
    }
  }

  span.small {
    color: #6b6b6b;
    font-size: 12px !important;
    display: block;
    padding-left: 4px;
    letter-spacing: -0.16px;
    margin-bottom: 24px;
    @media screen and (max-width: 1199px) {
      display: block;
    }
  }

  div.price {
    margin-bottom: 0;
  }

  a {
    position: relative;
    bottom: 0;
  }
`;

const PricingColumn = styled.div``;

const TableRow = styled.tr`
  background: ${(props) => {
    let color;
    if (props.feature.highlightedSubGroup) {
      color = '#FDFDFE';
    } else if (props.feature.highlightedGroup) {
      color = '#F9F9F9';
    }
    return color;
  }};
`;

const TableHeaderTop = styled.th`
  border-right: none;
`;

const TableBody = styled.tbody`
  th {
    border-right: 1px solid #dee2e6;
  }
  td {
    border-right: 1px solid #dee2e6;
    text-align: center;
  }
  td.align-top {
    text-align: left;
  }
`;

const runtime = typeof document === 'object';

class PricingTableLarge extends React.Component {
  constructor(props) {
    super(props);
    const { data } = this.props;
    this.state = { data };
  }

  render() {
    const { data } = this.state;
    const { event } = data;
    const itemTooltip = (event && event.itemTooltip) || '';
    const itemClicked = (event && event.itemClicked) || '';
    if (runtime) {
      const oPriceToggle = window.priceToggle;

      window.priceToggle = (value) => {
        if (typeof oPriceToggle === 'function') {
          oPriceToggle(value);
        }

        if (value === 'month') {
          updateDisplay('basic-annual', 'none');
          updateDisplay('pro-annual', 'none');
          updateDisplay('enterprise-annual', 'none');
          updateDisplay('basic-month', 'block');
          updateDisplay('pro-month', 'block');
          updateDisplay('enterprise-month', 'block');
        } else {
          updateDisplay('basic-annual', 'block');
          updateDisplay('pro-annual', 'block');
          updateDisplay('enterprise-annual', 'block');
          updateDisplay('basic-month', 'none');
          updateDisplay('pro-month', 'none');
          updateDisplay('enterprise-month', 'none');
        }
      };
    }

    return (
      <div>
        <div id="pricing-table-large" className="d-none d-lg-block rounded">
          <table
            className="table table-light rounded"
            style={{ borderCollapse: 'separate', borderSpacing: '0' }}
          >
            <thead
              className="text-left sticky-top"
              style={{ top: '53px', zIndex: '1070' }}
            >
              <tr>
                <th
                  scope="col"
                  className="border-bottom border-top v5_mt-3 bg-white rounded text-left"
                  style={{ width: '20%' }}
                />
                {data.plans &&
                  data.plans.map((plan) => {
                    // Don't include border right on enterprise since it's the right most plan
                    if (plan.id === 'postman-enterprise') {
                      return (
                        <TableHeaderColumn
                          scope="col"
                          className="border-bottom border-top bg-white rounded position-relative"
                          key={pmUuid()}
                          style={{ width: '20%' }}
                        >
                          <h2 className="h3 plan-ultimate">{plan.name}</h2>
                          <PricingColumn
                            className="d-flex align-items-center price"
                            plan={plan.id}
                          >
                            <div
                              className="body"
                              dangerouslySetInnerHTML={{
                                __html: plan.body.join('')
                              }}
                            />
                          </PricingColumn>
                          <div
                            className={
                              plan.button.isEnterprise
                                ? 'price row annual'
                                : 'row'
                            }
                            data-suppress={
                              plan.button.isEnterprise ? 'pro-annual' : ''
                            }
                          >
                            {plan.button && (
                              <div className="col-12">
                                <PricingButton
                                  isEnterprise={plan.button.isEnterprise}
                                  className={
                                    plan.buttonTwo ? 'mr-1 mb-lg-2' : ''
                                  }
                                  buttonType={plan.button.buttonType}
                                  id={plan.button.id}
                                  dataTest={plan.button.test}
                                  aria-label={plan.button.ariaLabel}
                                  href={plan.button.href}
                                  target={plan.button.target}
                                  title={plan.button.title}
                                  rel={plan.button.rel}
                                  event={itemClicked}
                                  eventProp={`{\"cta_link_to\":\"${plan.button.href}\",\"cta_style\":\"${plan.button.buttonType}\",\"cta_text\":\"${plan.button.title}\",\"cta_type\":\"button\"}`}
                                  onClick={() => {
                                    triggerGA(
                                      'pricing-page',
                                      `${plan.button.id}`
                                    );
                                  }}
                                >
                                  {plan.button.title}
                                </PricingButton>

                                {plan.buttonTwo && (
                                  <div className="mt-2">
                                    <PricingButton
                                      isEnterprise={plan.buttonTwo.isEnterprise}
                                      buttonType={plan.buttonTwo.buttonType}
                                      id={plan.buttonTwo.id}
                                      dataTest={plan.buttonTwo.test}
                                      aria-label={plan.buttonTwo.ariaLabel}
                                      href={plan.buttonTwo.href}
                                      target={plan.buttonTwo.target}
                                      title={plan.buttonTwo.title}
                                      rel={plan.buttonTwo.rel}
                                      event={itemClicked}
                                      eventProp={`{\"cta_link_to\":\"${plan.button.href}\",\"cta_style\":\"${plan.button.buttonType}\",\"cta_text\":\"${plan.button.title}\",\"cta_type\":\"button\"}`}
                                      onClick={() => {
                                        triggerGA(
                                          'pricing-page',
                                          `${plan.button.id}`
                                        );
                                      }}
                                    >
                                      {plan.buttonTwo.title}
                                    </PricingButton>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        </TableHeaderColumn>
                      );
                    }
                    return (
                      <TableHeaderColumn
                        scope="col"
                        className="border-bottom border-top border-top bg-white"
                        key={pmUuid()}
                        style={{ width: '20%' }}
                      >
                        <h2 className="h3">{plan.name}</h2>
                        <PricingColumn
                          className="d-flex align-items-center price"
                          plan={plan.id}
                        >
                          <div
                            className="body"
                            dangerouslySetInnerHTML={{
                              __html: plan.body.join('')
                            }}
                          />
                        </PricingColumn>
                        {plan.additionalText ? (
                          <p className="small mb-4">{plan.additionalText}</p>
                        ) : (
                          <div />
                        )}
                        {plan.button && (
                          <div>
                            <PricingButton
                              className={plan.buttonTwo ? 'mr-1 mb-lg-2' : ''}
                              buttonType={plan.button.buttonType}
                              id={plan.button.id}
                              dataTest={plan.button.test}
                              aria-label={plan.button.ariaLabel}
                              href={plan.button.href}
                              target={plan.button.target}
                              rel={plan.button.rel}
                              event={itemClicked}
                              eventProp={`{\"cta_link_to\":\"${plan.button.href}\",\"cta_style\":\"${plan.button.buttonType}\",\"cta_text\":\"${plan.button.title}\",\"cta_type\":\"button\"}`}
                              onClick={() => {
                                triggerGA('pricing-page', `${plan.button.id}`);
                              }}
                            >
                              {plan.button.title}
                            </PricingButton>
                            {plan.buttonTwo && (
                              <div className="mt-2">
                                <PricingButton
                                  className="font-weight-normal"
                                  buttonType={plan.buttonTwo.buttonType}
                                  src={plan.buttonTwo.href}
                                  target={
                                    plan.buttonTwo.target
                                      ? plan.buttonTwo.target
                                      : 'same-tab'
                                  }
                                  gaCategory="pricing-page"
                                  gaLabel={plan.buttonTwo.id}
                                  id={plan.buttonTwo.id}
                                  ariaLabel={plan.buttonTwo.ariaLabel}
                                  dataTest={plan.buttonTwo.test}
                                  rel={plan.buttonTwo.rel}
                                  event={itemClicked}
                                  eventProp={`{\"cta_link_to\":\"${plan.buttonTwo.href}\",\"cta_style\":\"${plan.buttonTwo.buttonTwoType}\",\"cta_text\":\"${plan.buttonTwo.title}\",\"cta_type\":\"button\"}`}
                                  onClick={() => {
                                    triggerGA(
                                      'pricing-page',
                                      `${plan.buttonTwo.id}`
                                    );
                                  }}
                                >
                                  {plan.buttonTwo.title}
                                </PricingButton>
                              </div>
                            )}
                          </div>
                        )}
                      </TableHeaderColumn>
                    );
                  })}
              </tr>
            </thead>
            <TableBody className="text-left">
              {data.features &&
                data.features.map((feature) => {
                  const cells = feature.plans.map((plan) => {
                    // All Columns except Enterprise, need border-right
                    if (plan.name !== 'postman-enterprise') {
                      // Is it boolean or is it string?
                      if (typeof plan.included === 'string') {
                        const planIncludedCheck =
                          (plan.addCheckmarkNextToText &&
                            `<img
                          style={{ height: '16px' }}
                          alt="Available"
                          src="https://voyager.postman.com/icon/checkbox-outline-green-icon.svg"
                        /> &nbsp; ${plan.included}<br>${
                              plan.includedTwo || ''
                            }`) ||
                          `${plan.included}<br>${plan.includedTwo || ''}`;

                        return (
                          <td
                            className={
                              plan.topAlign
                                ? 'border-bottom align-top'
                                : 'border-bottom align-middle'
                            }
                            key={pmUuid()}
                          >
                            <p
                              className="mb-0 small"
                              dangerouslySetInnerHTML={{
                                __html: planIncludedCheck
                              }}
                            />
                          </td>
                        );
                      }
                      if (plan.included && !plan.tooltip) {
                        // if plan.included === true, green checkmark
                        return (
                          <td
                            className="border-bottom align-middle"
                            key={pmUuid()}
                          >
                            <p className="mb-0 small">
                              <img
                                style={{ height: '16px' }}
                                alt="Available"
                                src="https://voyager.postman.com/icon/checkbox-outline-green-icon.svg"
                              />
                            </p>
                          </td>
                        );
                      }
                      if (plan.included && plan.tooltip) {
                        // if plan.included === true, green checkmark
                        return (
                          <td
                            className="border-bottom align-middle"
                            key={pmUuid()}
                          >
                            <a
                              tabIndex="0"
                              href="##"
                              className="pm-tooltip"
                              role="button"
                              data-toggle="tooltip"
                              data-placement="top"
                              title={plan.tooltip}
                            >
                              <img
                                src="https://voyager.postman.com/icon/plus-outline-green-icon.svg"
                                alt="Plus. Icon."
                                style={{ height: '13px' }}
                                onMouseOver={() => {
                                  window.pmt('amplitudeEvent', [
                                    `${itemTooltip}:${plan.tooltip}`
                                  ]);
                                }}
                              />
                            </a>
                          </td>
                        );
                      }
                      return (
                        <td
                          className="border-bottom align-middle"
                          key={pmUuid()}
                        >
                          <p className="mb-0 small">
                            <img
                              style={{ opacity: '1', height: '16px' }}
                              alt="Unavailable"
                              src="https://voyager.postman.com/icon/x-icon-grey.svg"
                            />
                          </p>
                        </td>
                      );
                    }
                    // Enterprise Column, Do not need border-right
                    if (
                      plan.addCheckmarkNextToText &&
                      typeof plan.included === 'string'
                    ) {
                      const planIncludedCheck =
                      (plan.addCheckmarkNextToText &&
                        `<img
                      style={{ height: '16px' }}
                      alt="Available"
                      src="https://voyager.postman.com/icon/checkbox-outline-green-icon.svg"
                    /> &nbsp; ${plan.included}<br>${
                          plan.includedTwo || ''
                        }`) ||
                      `${plan.included}<br>${plan.includedTwo || ''}`;
                      return (
                        <td
                          className="border-bottom align-middle"
                          key={pmUuid()}
                        >
                          <div className="d-flex">
                            <p
                              className="mb-0 small"
                              dangerouslySetInnerHTML={{
                                __html: planIncludedCheck
                              }}
                            />
                          </div>
                        </td>
                      );
                    }
                    if (typeof plan.included === 'string') {
    const planTwoItems = plan.includedTwo
      ? `${plan.included}<br>${plan.includedTwo}`
      : plan.included;
                      return (
                        <td
                          className={
                            plan.topAlign
                              ? 'border-bottom align-top'
                              : 'border-bottom align-middle'
                          }
                          key={pmUuid()}
                        >
                          <p
                            className="mb-0 small"
                            dangerouslySetInnerHTML={{ __html: planTwoItems }}
                          />
                        </td>
                      );
                    }
                    if (plan.included && !plan.tooltip) {
                      // if plan.included === true, green checkmark
                      return (
                        <td
                          className="border-bottom align-middle"
                          key={pmUuid()}
                        >
                          <p className="mb-0 small">
                            <img
                              style={{ height: '16px' }}
                              alt="Available"
                              src="https://voyager.postman.com/icon/checkbox-outline-green-icon.svg"
                            />
                          </p>
                        </td>
                      );
                    }
                    if (plan.included && plan.tooltip) {
                      // if plan.included === true, green checkmark
                      return (
                        <td
                          className="border-bottom align-middle"
                          key={pmUuid()}
                        >
                          <a
                            tabIndex="0"
                            href="##"
                            className="pm-tooltip"
                            role="button"
                            data-toggle="tooltip"
                            data-placement="top"
                            title={plan.tooltip}
                          >
                            <img
                              src="https://voyager.postman.com/icon/plus-outline-green-icon.svg"
                              alt="Plus. Icon."
                              style={{ height: '13px' }}
                              onMouseOver={() => {
                                window.pmt('amplitudeEvent', [
                                  `${itemTooltip}:${plan.tooltip}`
                                ]);
                              }}
                            />
                          </a>
                        </td>
                      );
                    }
                    return (
                      <td className="border-bottom align-middle" key={pmUuid()}>
                        <p className="mb-0 small">
                          <img
                            style={{ opacity: '1', height: '16px' }}
                            alt="Unavailable"
                            src="https://voyager.postman.com/icon/x-icon-grey.svg"
                          />
                        </p>
                      </td>
                    );
                  });
                  return (
                    <TableRow
                      key={pmUuid()}
                      className="tr-style"
                      feature={feature}
                    >
                      {feature.highlightedGroup && (
                        /* Highlighted Category Title (Add tooltip if needed ) */
                        <td
                          colSpan="12"
                          className="border-bottom text-left align-middle"
                        >
                          <div className="row">
                            <div className="col-md-10">
                              <p className="mb-0 feature-text text-left strong">
                                {feature.highlightedTitle}
                              </p>
                            </div>
                          </div>
                        </td>
                      )}
                      {!feature.highlightedGroup && (
                        /* Plan features inside category ( A tag and P element ) */
                        <TableHeaderTop
                          scope="row"
                          className="border-bottom text-left font-weight-normal align-middle"
                        >
                          {feature.href && feature.popover && (
                            <div
                              className="row"
                              data-test="feature-and-popover"
                            >
                              <div className="col-sm-10" data-test="link">
                                <a
                                  type="tertiary"
                                  href={feature.href}
                                  className="mb-0 feature-text feature-link text-left"
                                  aria-label={feature.ariaLabel || null}
                                  data-event={feature.event}
                                  data-event-prop={feature.eventProp}
                                >
                                  {feature.title}
                                </a>
                              </div>
                              <div className="col-sm-2" data-test="tooltip">
                                <a
                                  tabIndex="0"
                                  href="##"
                                  className="pm-tooltip"
                                  role="button"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title={feature.popover}
                                >
                                  <img
                                    src="https://voyager.postman.com/icon/question-mark-icon-postman.svg"
                                    alt="Question. Icon."
                                    style={{ height: '15px', opacity: '0.7' }}
                                    onMouseOver={() => {
                                      window.pmt('amplitudeEvent', [
                                        `${itemTooltip}:${feature.title}`
                                      ]);
                                    }}
                                  />
                                </a>
                              </div>
                            </div>
                          )}
                          {!feature.href && feature.popover && (
                            <div
                              className="row"
                              data-test="feature-and-popover"
                            >
                              <div className="col-sm">
                                <p className="mb-0">{feature.title}</p>
                              </div>
                              <div className="col-sm-2" data-test="tooltip">
                                <a
                                  tabIndex="0"
                                  href="##"
                                  className="pm-tooltip"
                                  role="button"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title={feature.popover}
                                >
                                  <img
                                    src="https://voyager.postman.com/icon/question-mark-icon-postman.svg"
                                    alt="Question. Icon."
                                    style={{ height: '15px', opacity: '0.7' }}
                                    onMouseOver={() => {
                                      window.pmt('amplitudeEvent', [
                                        `${itemTooltip}:${feature.title}`
                                      ]);
                                    }}
                                  />
                                </a>
                              </div>
                            </div>
                          )}
                          {feature.href && !feature.popover && (
                            <div className="row" data-test="feature-no-popover">
                              <div className="col-sm">
                                <a
                                  type="tertiary"
                                  href={feature.href}
                                  className="mb-0 feature-text feature-link text-left"
                                  aria-label={feature.ariaLabel}
                                  data-event={feature.event}
                                  data-event-prop={feature.eventProp}
                                >
                                  {feature.title}
                                </a>
                              </div>
                            </div>
                          )}
                          {!feature.href && !feature.popover && (
                            <div
                              className="row"
                              data-test="no-feature-no-popover"
                            >
                              <div className="col-sm">
                                <p className="mb-0">{feature.title}</p>
                              </div>
                            </div>
                          )}
                        </TableHeaderTop>
                      )}
                      {cells}
                    </TableRow>
                  );
                })}
            </TableBody>
          </table>
          <p className="small text-right" />
        </div>
      </div>
    );
  }
}

export default PricingTableLarge;
